// extracted by mini-css-extract-plugin
export default {"link":"style_link__TsKmF","centerGrid":"style_centerGrid__mEKE8","img":"style_img__SlR2b","namegame":"style_namegame__lV1Ok","center":"style_center__lfDkD"};